const currency = (value) => {
  return value;
};

export function handleSelect(event) {
  event.target.select();
}

export default currency;
